import PropTypes from 'prop-types';

export const AKTORTYPE_BYGGHERRE = 'BYGGHERRE';
export const AKTORTYPE_UTFOERENDE_ENTREPRENOER = 'UTFOERENDE_ENTREPRENOER';
export const AKTORTYPE_UTFOERENDE_ENTREPRENOER_VARSLING =
	'UTFOERENDE_ENTREPRENOER_VARSLING';
export const AKTORTYPE_ANSVARSHAVENDE = 'ANSVARSHAVENDE';
export const AKTORTYPE_STEDSANSVARLIG = 'STEDSANSVARLIG';
export const AKTORTYPE_KONTAKT_FOR_SOKER = 'KONTAKT_FOR_SOKER';

export const aktortypePropType = PropTypes.oneOf([
	AKTORTYPE_BYGGHERRE,
	AKTORTYPE_UTFOERENDE_ENTREPRENOER,
	AKTORTYPE_UTFOERENDE_ENTREPRENOER_VARSLING,
	AKTORTYPE_ANSVARSHAVENDE,
	AKTORTYPE_STEDSANSVARLIG,
	AKTORTYPE_KONTAKT_FOR_SOKER,
]);

export const TYPE_DAGER_HVERDAGER = 'HVERDAGER';
export const TYPE_DAGER_HELE_UKEN = 'HELE_UKEN';
export const TYPE_DAGER_HELG = 'HELG';

export const PERIODISERING_TIMER = 'TIMER';
export const PERIODISERING_DAGER = 'DAGER';
export const PERIODISERING_UKER = 'UKER';

export const kontaktinformasjonPropType = PropTypes.shape({
	epostadresse: PropTypes.string,
	mobiltelefonnummer: PropTypes.string,
});

export const vedleggPropType = PropTypes.shape({
	id: PropTypes.string,
	filnavn: PropTypes.string,
	mimetype: PropTypes.string,
	storrelse: PropTypes.number,
});

export const kompetansebevisPropType = PropTypes.shape({
	utlopsdato: PropTypes.string,
	kompetansebevis: vedleggPropType,
});

export const fysiskpersonPropType = PropTypes.shape({
	aktortype: aktortypePropType,
	fornavn: PropTypes.string,
	etternavn: PropTypes.string,
	navn: PropTypes.string,
	kontaktinformasjon: kontaktinformasjonPropType,
	kompetansebevis: kompetansebevisPropType,
	type: PropTypes.oneOf(['FysiskPerson']),
});

export const organisasjonsnummerPropType = PropTypes.shape({
	identifikator: PropTypes.string,
});

export const enhetPropType = PropTypes.shape({
	aktortype: aktortypePropType,
	organisasjonsnummer: organisasjonsnummerPropType,
	kontaktperson: fysiskpersonPropType,
	type: PropTypes.oneOf(['Enhet']),
});

export const kontaktPropType = PropTypes.oneOfType([
	fysiskpersonPropType,
	enhetPropType,
]);

export const PLANTYPE_SPESIELL = 'SPESIELL';
export const PLANTYPE_GENERELL = 'GENERELL';
export const PLANTYPE_UTGATT = 'UTGATT';
export const plantypePropType = PropTypes.oneOf([
	PLANTYPE_GENERELL,
	PLANTYPE_SPESIELL,
	PLANTYPE_UTGATT,
]);

export const arbeidsbeskrivelseAnnetPropType = PropTypes.shape({
	tittel: PropTypes.string,
	beskrivelse: PropTypes.string,
	valgt: PropTypes.bool,
});

export const alternativMedTekstPropType = PropTypes.shape({
	felt: PropTypes.string,
	tekst: PropTypes.string,
	valgt: PropTypes.bool,
});

export const arbeidstyperPropType = PropTypes.shape({
	annet: arbeidsbeskrivelseAnnetPropType,
	arbeidstyper: PropTypes.arrayOf(alternativMedTekstPropType),
});

export const trafikantgrupperPropType = PropTypes.shape({
	andre: PropTypes.shape({
		tekst: PropTypes.string,
		valgt: PropTypes.bool,
	}),
	trafikantgrupper: PropTypes.arrayOf(PropTypes.string),
});

export const tiltakPropType = PropTypes.shape({
	valgt: PropTypes.bool,
	alternativer: PropTypes.arrayOf(alternativMedTekstPropType),
});

export const vegarbeidsbeskrivelsePropType = PropTypes.shape({
	arbeistype: PropTypes.shape({
		spesiellPlan: arbeidstyperPropType,
		generellPlan: arbeidstyperPropType,
	}),
	trafikantgrupper: PropTypes.shape({
		spesiellPlan: trafikantgrupperPropType,
		generellPlan: trafikantgrupperPropType,
	}),
	spesielleTiltak: PropTypes.objectOf(tiltakPropType),
	generelleTiltak: PropTypes.objectOf(tiltakPropType),
	beredskapsplan: PropTypes.bool,
	arbeidIBevegelse: PropTypes.bool,
});

export const periodiseringPropType = PropTypes.oneOf([
	PERIODISERING_DAGER,
	PERIODISERING_TIMER,
	PERIODISERING_UKER,
]);

export const arbeidsvarighetPropType = PropTypes.shape({
	periodisering: periodiseringPropType,
	varighet: PropTypes.number,
});

export const typeDagerPropType = PropTypes.oneOf([
	TYPE_DAGER_HELG,
	TYPE_DAGER_HELE_UKEN,
	TYPE_DAGER_HVERDAGER,
]);
export const punktMedVedleggPropType = PropTypes.shape({
	vedlegg: PropTypes.arrayOf(vedleggPropType),
});

export const vegarbeidperiodePropType = PropTypes.shape({
	fra: PropTypes.string,
	til: PropTypes.string,
	arbeidsvarighet: arbeidsvarighetPropType,
	typeDager: typeDagerPropType,
	arbeidstidsperioder: PropTypes.arrayOf(PropTypes.object),
});

export const vegsystemPropType = PropTypes.shape({
	fase: PropTypes.string,
	id: PropTypes.string,
	nummer: PropTypes.string,
	vegkategori: PropTypes.string,
	versjon: PropTypes.string,
});

export const strekningPropType = PropTypes.shape({
	id: PropTypes.string,
	arm: PropTypes.bool,
	delstrekning: PropTypes.number,
	meter: PropTypes.number,
	strekning: PropTypes.number,
	trafikantgruppe: PropTypes.string,
	versjon: PropTypes.string,
});

export const sideanleggPropType = PropTypes.shape({
	meter: PropTypes.number,
	sideanlegg: PropTypes.string,
	trafikantgruppe: PropTypes.string,
	sideanleggsdel: PropTypes.string,
});

export const kryssystemPropType = PropTypes.shape({
	kryssystem: PropTypes.string,
	kryssdel: PropTypes.string,
	meter: PropTypes.number,
	trafikantgruppe: PropTypes.string,
});

export const vegsystemreferansePropType = PropTypes.shape({
	vegsystem: vegsystemPropType,
	strekning: strekningPropType,
	kryssystem: kryssystemPropType,
	sideanlegg: sideanleggPropType,
});

export const koordinatPropType = PropTypes.shape({
	x: PropTypes.number,
	y: PropTypes.number,
	z: PropTypes.number,
	srid: PropTypes.string,
});

export const kommunePropType = PropTypes.shape({
	kommunenummer: PropTypes.string,
	kommunenavn: PropTypes.string,
});

export const fartsgrensePropType = PropTypes.shape({
	fartsgrense: PropTypes.number,
	gyldigFraDato: PropTypes.date,
});
export const trafikkmendgePropType = PropTypes.shape({
	andelLangeKjoretoy: PropTypes.number,
	arsdognstrafikk: PropTypes.number,
	gjelderAr: PropTypes.number,
});

export const vegarbeidsposisjonPropType = PropTypes.shape({
	avstand: PropTypes.number,
	vegsystemreferanse: vegsystemreferansePropType,
	koordinat: koordinatPropType,
	kommune: kommunePropType,
	fartsgrenser: PropTypes.arrayOf(fartsgrensePropType),
	trafikkmengder: PropTypes.arrayOf(trafikkmendgePropType),
});

export const fylkePropType = PropTypes.shape({
	fylkesnummer: PropTypes.string,
	fylkesnavn: PropTypes.string,
	kommuner: PropTypes.arrayOf(kommunePropType),
});

export const VEGTYPE_RIKSVEG = 'RIKSVEG';
export const VEGTYPE_RIKSGANGVEG = 'RIKSGANGVEG';
export const VEGTYPE_FYLKESVEG = 'FYLKESVEG';
export const VEGTYPE_FYLKESGANGVEG = 'FYLKESGANGVEG';

export const vegtypePropType = PropTypes.oneOf([
	VEGTYPE_RIKSVEG,
	VEGTYPE_RIKSGANGVEG,
	VEGTYPE_FYLKESVEG,
	VEGTYPE_FYLKESGANGVEG,
]);

export const kontraktsomraadePropType = PropTypes.shape({
	navn: PropTypes.string,
	id: PropTypes.number,
});

export const omraadeGenerellPlanPropType = PropTypes.shape({
	fylker: PropTypes.arrayOf(fylkePropType),
	vegtyper: vegtypePropType,
	kontraktsomraade: kontraktsomraadePropType,
});

export const GENERELL_PLANTYPE_OMRAADE = 'OMRAADE';
export const GENERELL_PLANTYPE_KONTRAKT = 'KONTRAKT';

export const vegarbeidsstedPropType = PropTypes.shape({
	vegarbeidsposisjoner: PropTypes.arrayOf(vegarbeidsposisjonPropType),
	omraadeGenerellPlan: omraadeGenerellPlanPropType,
});

const vegstrekningPropType = PropTypes.shape({
	fra: vegarbeidsposisjonPropType,
	til: vegarbeidsposisjonPropType,
	geometri: PropTypes.arrayOf(koordinatPropType),
	fartsgrenser: PropTypes.arrayOf(fartsgrensePropType),
	trafikkmengder: PropTypes.arrayOf(trafikkmendgePropType),
});

export const arbeidsrutePropType = PropTypes.shape({
	vegposisjoner: PropTypes.arrayOf(vegarbeidsposisjonPropType),
	punkter: PropTypes.arrayOf(koordinatPropType),
	vegstrekninger: PropTypes.arrayOf(vegstrekningPropType),
});

export const arbeidsstedPropType = PropTypes.shape({
	arbeidsruter: PropTypes.arrayOf(arbeidsrutePropType),
});

export const vegarbeidPropType = PropTypes.shape({
	kontakter: PropTypes.arrayOf(kontaktPropType),
	vegarbeidsbeskrivelse: vegarbeidsbeskrivelsePropType,
	vegarbeidssted: vegarbeidsstedPropType,
	vegarbeidsperiode: vegarbeidperiodePropType,
	arbeidssted: arbeidsstedPropType,
	varslingsplan: punktMedVedleggPropType,
});

export const soknadPropType = PropTypes.shape({
	id: PropTypes.number,
	forrige: PropTypes.shape({
		id: PropTypes.number,
	}),
	prosjekttittel: PropTypes.string,
	vegarbeid: vegarbeidPropType,
	plantype: plantypePropType,
	tilleggsinformasjon: punktMedVedleggPropType,
	soknadsdokument: vedleggPropType,
});

export const tiltakRekkefolgeKonfigPropType = PropTypes.shape({
	generellPlan: PropTypes.arrayOf(PropTypes.string),
	spesiellPlan: PropTypes.arrayOf(PropTypes.string),
});
